<div class="container-fluid p-0 m-0">
    <div class="col-lg-12 m-0 grid-margin stretch-card p-2">
        <div class="bg-white rounded shadow">
            <!-- <div class="tabbable-responsive"> -->
            <div class="tabbable p-3">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" id="region-tab" data-toggle="tab" href="#region" role="tab"
                            aria-controls="region" aria-selected="true">Region</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="showroom-tab" data-toggle="tab" href="#showroom" role="tab"
                            aria-controls="showroom" aria-selected="false">Showroom</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="assets-tab" data-toggle="tab" href="#assets" role="tab"
                            aria-controls="assets" aria-selected="false">Assets</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="creative-tab" data-toggle="tab" href="#creative" role="tab"
                            aria-controls="creative" aria-selected="false">Creative</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="floor-tab" data-toggle="tab" href="#floor" role="tab"
                            aria-controls="floor" aria-selected="false">Floor</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link " id="location-tab" data-toggle="tab" href="#location" role="tab"
                            aria-controls="location" aria-selected="false">Location</a>
                    </li>
                    <!-- <li class="nav-item">
              <a class="nav-link" id="campaign-tab" data-toggle="tab" href="#campaign" role="tab" aria-controls="campaign" aria-selected="false">Campaign</a>
            </li> -->
                    <li class="nav-item">
                        <a class="nav-link" id="vendor-tab" data-toggle="tab" href="#vendor" role="tab"
                            aria-controls="vendor" aria-selected="false">Vendor</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link " id="user-tab" data-toggle="tab" href="#user" role="tab"
                            aria-controls="vendor" aria-selected="false">User Role</a>
                    </li>
                </ul>
                <!-- </div> -->
            </div>
        </div>

        <div class="tab-content">
            <div class="tab-pane fade  show active" id="region" role="tabpanel" aria-labelledby="region-tab">
                <div class="row  m-0 p-0 w-100">
                    <div class="col-lg-8 col-md-12 m-0 p-1">
                        <div class="bg-white rounded shadow pb-3">
                            <div class="title-header">
                                <h5 class="mp-0">Region Lists</h5>
                            </div>
                            <div class="custom-search my-auto pl-3 pt-2">
                                <input type="filter" class="custom-search-input" placeholder="Search for"
                                    autocomplete="off" [(ngModel)]="filterString"
                                    (ngModelChange)="onFilterChange('region')" tabindex="1">
                            </div>
                            <div class="p-2">
                                <div class="table-responsive p-1 box-table">
                                    <table id="region-table" class="table box-table table-borderless m-0 p-0" matSort
                                        (matSortChange)="sortRegionData($event)" matSortActive="name"
                                        matSortDirection="asc" matSortDisableClear>
                                        <thead class="">
                                            <tr class="justify-content-center ">
                                                <th class="text-center">
                                                    <p class="m-0">#</p>
                                                </th>
                                                <th class="th-center" mat-sort-header="name">
                                                    <p class="m-0 pl-4">Region Name</p>
                                                </th>
                                                <th class="text-center">
                                                    <p class="m-0">Image</p>
                                                </th>
                                                <th class="" mat-sort-header="is_suspended">
                                                    <p class="m-0">Status</p>
                                                </th>
                                                <th class="text-center">
                                                    <p class="m-0">Action</p>
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody class="">
                                            <tr class=""
                                                *ngFor="let data of sortedRegionData | slice: (pageR-1) * pageSizeR : pageR * pageSizeR  ; let i=index">
                                                <td class="text-center">
                                                    <p class="m-0 pl-2">{{i+1}}</p>
                                                </td>
                                                <td class="text-center">
                                                    <p class="m-0">{{data.name}}</p>
                                                </td>
                                                <td class="text-center ">
                                                    <div class="pl-4 media justify-content-center">
                                                        <img alt="" onerror="this.src='/assets/grt.svg'"
                                                            src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}"
                                                            class="grt-dummy mr-3 pointer">
                                                    </div>
                                                </td>

                                                <td class="text-center">
                                                    <div class="row" *ngIf="data.is_suspended===0">
                                                        <span class="dot-active"></span>
                                                        <p class="m-0">Active</p>
                                                    </div>
                                                    <div class="row" *ngIf="data.is_suspended===1">
                                                        <span class="dot-suspend"></span>
                                                        <p class="m-0">Suspended</p>
                                                    </div>

                                                </td>

                                                <td class="text-center">
                                                    <div class="align-items-center m-0 p-0">
                                                        <i class='fa fa-pencil-square-o light_grey fa-md mr-3  pointer'
                                                            (click)="editRegion(data.id)"> </i>
                                                        <i class='fa fa-ban fa-md light_grey mr-3 pointer'
                                                            (click)="suspendRegion(data.id,data.name,data.is_suspended)"></i>
                                                        <i class='fa fa-trash fa-md light_grey pointer'
                                                            (click)="deleteRegion(data.id,data.name)"></i>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div class="text-center p-5"
                                        *ngIf="sortedRegionData && sortedRegionData.length === 0">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72"
                                            fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                            <path
                                                d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z" />
                                        </svg>
                                        <p class="m-0 no-record"> No Record Found </p>
                                    </div>
                                </div>
                                <div class="mt-3 sl-pagination text-center justify-content-center"
                                    *ngIf="sortedRegionData">
                                    <ngb-pagination [(page)]="pageR" [rotate]="true" [ellipses]="false"
                                        [boundaryLinks]="true" [maxSize]="5" *ngIf="sortedRegionData.length > 10"
                                        [collectionSize]="sortedRegionData.length" aria-label="Default pagination"
                                        class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
                                </div>

                            </div>
                            <div class="text-right">
                                <button type="button" class="btn btn-danger mt-1 mr-3 btn-w"
                                    (click)="exportexcel('region-table', 'Region List')">Export to excel</button>
                            </div>
                        </div>

                    </div>
                    <div class="col-lg-4 col-md-12 m-0 p-1">
                        <div class="bg-white rounded shadow pb-3">
                            <div class="title-header" *ngIf="isAddRegion">
                                <h5 class="mp-0">Add Region</h5>
                            </div>
                            <div class="title-header" *ngIf="!isAddRegion">
                                <h5 class="mp-0">Update Region</h5>
                            </div>
                            <form [formGroup]="regionForm" (ngSubmit)="onRegionSubmit()" class="p-3">
                                <div class="form-group">
                                    <label for="name">Region Name</label>
                                    <input type="text" (keypress)="omit_special_char($event)" formControlName="name"
                                        class="file-select form-control"
                                        [ngClass]="{ 'is-invalid': regionSubmitted && f1.name.errors }" />
                                    <div *ngIf="regionSubmitted && f1.name.errors" class="invalid-feedback">
                                        <div *ngIf="f1.name.errors.required">Region Name is required</div>
                                        <div *ngIf="f1.name.errors.minlength">Region Name should be atleast of 3
                                            character.</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="label-header">Region Image:</label>
                                    <div class="uploader">
                                        <input id="file-upload" type="file" name="fileUpload" accept="image/*"
                                            (change)="onRegionFileChange($event)" />
                                        <label for="file-upload" id="file-drag">
                                            <img [src]="imageSrc" *ngIf="imageSrc" onerror="this.src='/assets/grt.svg'"
                                                id="file-image">
                                            <div id="start" *ngIf="!imageSrc">
                                                <i class="fa fa-download" aria-hidden="true"></i>
                                                <div class="label-header">Select a Picture</div>
                                            </div>

                                        </label>
                                        <!-- <div id="start" *ngIf="imageSrc" (click)="r_regionImage()">
                        <div class="label-header float-right"><u>Delete this Picture</u></div>
                      </div> -->
                                    </div>

                                </div>

                                <div class="text-center mt-3">
                                    <button *ngIf="isAddRegion" class="btn btn-success mt-2 mr-3 btn-w">Save</button>
                                    <button *ngIf="isAddRegion" class="btn btn-secondary mt-2 btn-w" type="reset"
                                        (click)="onReset()">Reset</button>
                                    <button *ngIf="!isAddRegion" class="btn btn-success mt-2 mr-3 btn-w">Update
                                        Region</button>
                                    <button *ngIf="!isAddRegion" class="btn btn-info btn-w mt-2 " type="cancel"
                                        (click)="addNewRegion()">Add Region</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="showroom" role="tabpanel" aria-labelledby="showroom-tab">
                <div class="row m-0 p-0 w-100">
                    <div class="col-lg-8 m-0 p-1 grid-margin stretch-card">
                        <div class="bg-white rounded shadow pb-3">
                            <div class="title-header">
                                <h5 class="mp-0">Showroom Lists</h5>
                            </div>
                            <div class="custom-search my-auto pl-3 pt-2">
                                <input type="filter" class="custom-search-input" placeholder="Search for"
                                    autocomplete="off" [(ngModel)]="filterString"
                                    (ngModelChange)="onFilterChange('showroom')" tabindex="1">
                            </div>
                            <div class="p-2">
                                <div class="table-responsive p-1 box-table">
                                    <table id="showroom-table" class="table box-table table-borderless m-0 p-0" matSort
                                        (matSortChange)="sortShowroomData($event)" matSortActive="name"
                                        matSortDirection="asc" matSortDisableClear>
                                        <thead class="">
                                            <tr class="justify-content-center ">
                                                <th class="text-center">
                                                    <p class="m-0">#</p>
                                                </th>
                                                <th class="th-center" mat-sort-header="regionName">
                                                    <p class="m-0 pl-4">Region Name</p>
                                                </th>
                                                <th class="th-center" mat-sort-header="name">
                                                    <p class="m-0 pl-4">Showroom Name</p>
                                                </th>
                                                <th class="text-center">
                                                    <p class="m-0">Image</p>
                                                </th>
                                                <th class="" mat-sort-header="is_suspended">
                                                    <p class="m-0">Status</p>
                                                </th>
                                                <th class="text-center">
                                                    <p class="m-0">Action</p>
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody class="">
                                            <tr class=""
                                                *ngFor="let data of sortedShowroomData | slice: (pageS-1) * pageSizeS : pageS * pageSizeS;let i=index">
                                                <td class="text-center">
                                                    <p class="m-0 pl-2">{{i+1}}</p>
                                                </td>
                                                <td class="text-center">
                                                    <p class="m-0">{{data.regionName}}</p>
                                                </td>
                                                <td class="text-center">
                                                    <p class="m-0">{{data.name}}</p>
                                                </td>
                                                <td class="text-center ">
                                                    <div class="pl-4 media justify-content-center">
                                                        <img alt="" onerror="this.src='/assets/grt.svg'"
                                                            src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}"
                                                            class="grt-dummy mr-3 pointer">
                                                    </div>
                                                </td>


                                                <td class="text-center">
                                                    <div class="row" *ngIf="data.is_suspended===0">
                                                        <span class="dot-active"></span>
                                                        <p class="m-0">Active</p>
                                                    </div>
                                                    <div class="row" *ngIf="data.is_suspended===1">
                                                        <span class="dot-suspend"></span>
                                                        <p class="m-0">Suspended</p>
                                                    </div>

                                                </td>

                                                <td class="text-center">
                                                    <div class="align-items-center m-0 p-0">
                                                        <i class='fa fa-pencil-square-o light_grey fa-md mr-3  pointer'
                                                            (click)="editShowroom(data.id)"> </i>
                                                        <i class='fa fa-ban fa-md light_grey mr-3 pointer'
                                                            (click)="suspendShowroom(data.id,data.name,data.is_suspended)"></i>
                                                        <i class='fa fa-trash fa-md light_grey pointer'
                                                            (click)="deleteShowroom(data.id,data.name)"></i>
                                                    </div>
                                                </td>


                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="text-center p-5"
                                        *ngIf="sortedShowroomData && sortedShowroomData.length === 0">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72"
                                            fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                            <path
                                                d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z" />
                                        </svg>
                                        <p class="m-0 no-record"> No Record Found </p>
                                    </div>
                                </div>
                                <div class="mt-3 sl-pagination text-center justify-content-center"
                                    *ngIf="sortedShowroomData">
                                    <ngb-pagination [(page)]="pageS" [rotate]="true" [ellipses]="false"
                                        [boundaryLinks]="true" [maxSize]="5" *ngIf="sortedShowroomData.length > 10"
                                        [collectionSize]="sortedShowroomData.length" aria-label="Default pagination"
                                        class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
                                </div>

                            </div>
                            <div class="text-right">
                                <button type="button" class="btn btn-danger mt-1 mr-3 btn-w"
                                    (click)="exportexcel('showroom-table', 'Showroom List')">Export to excel</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4  m-0 p-1 grid-margin stretch-card">
                        <div class="bg-white rounded shadow pb-3">
                            <div class="title-header" *ngIf="isAddShowroom">
                                <h5 class="mp-0">Add Showroom</h5>
                            </div>
                            <div class="title-header" *ngIf="!isAddShowroom">
                                <h5 class="mp-0">Update Showroom</h5>
                            </div>

                            <form [formGroup]="showroomForm" (ngSubmit)="onShowroomSubmit()" class="p-3">

                                <div class="form-group">
                                    <label>Select Region</label>
                                    <select [(ngModel)]="selected_User_Region" formControlName="regionId"
                                        class="custom-select round"
                                        [ngClass]="{ 'is-invalid': showroomSubmitted && f2.regionId.errors }">
                                        <option value="">Select Region</option>
                                        <option *ngFor="let data of RegionDataLists" [value]=data.id>{{data.name}}
                                        </option>
                                    </select>
                                    <div *ngIf="showroomSubmitted && f2.regionId.errors" class="invalid-feedback">
                                        <div *ngIf="f2.regionId.errors.required">Region is required</div>
                                    </div>

                                </div>


                                <div class="form-group">
                                    <label for="name">Showroom Name</label>
                                    <input type="text" (keypress)="omit_special_char($event)"
                                        formControlName="showroomName" class="form-control"
                                        [ngClass]="{ 'is-invalid': showroomSubmitted && f2.showroomName.errors }" />
                                    <div *ngIf="showroomSubmitted && f2.showroomName.errors" class="invalid-feedback">
                                        <div *ngIf="f2.showroomName.errors.required">Showroom Name is required</div>
                                        <div *ngIf="f2.showroomName.errors.minlength">Showroom Name should be atleast of
                                            3 character.</div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="label-header">Showroom Image:</label>
                                    <div class="uploader">

                                        <input id="file-upload-showroom" type="file" name="fileUpload" accept="image/*"
                                            (change)="onShowroomFileChange($event)" />

                                        <label for="file-upload-showroom" id="file-drag">
                                            <img [src]="imageShowroomSrc" *ngIf="imageShowroomSrc" id="file-image"
                                                onerror="this.src='/assets/grt.svg'">
                                            <div id="start" *ngIf="!imageShowroomSrc">
                                                <i class="fa fa-download" aria-hidden="true"></i>
                                                <div class="label-header">Select a Picture</div>
                                            </div>
                                            <!-- <div id="start" *ngIf="imageShowroomSrc">
                                <div class="label-header"><u>Delete this Picture</u></div>
                              </div> -->
                                        </label>
                                    </div>
                                </div>
                                <div class="text-center mt-3">
                                    <button *ngIf="isAddShowroom" class="btn btn-success mr-3 mt-2 btn-w">Save</button>
                                    <button *ngIf="isAddShowroom" class="btn btn-secondary btn-w mt-2 " type="reset"
                                        (click)="onReset()">Reset</button>
                                    <button *ngIf="!isAddShowroom" class="btn btn-success mr-3 mt-2  btn-w">Update
                                        Showroom</button>
                                    <button *ngIf="!isAddShowroom" class="btn btn-info btn-w mt-2 " type="cancel"
                                        (click)="addNewShowroom()">Add Showroom</button>
                                </div>
                            </form>


                        </div>
                    </div>

                </div>
            </div>
            <div class="tab-pane fade" id="assets" role="tabpanel" aria-labelledby="assets-tab">
                <div class="row m-0 p-0 ">
                    <div class="col-lg-8 m-0 p-1 grid-margin stretch-card">
                        <div class="bg-white rounded shadow pb-3">
                            <div class="title-header">
                                <h5 class="mp-0">Assets Lists</h5>
                            </div>
                            <div class="custom-search my-auto pl-3 pt-2">
                                <input type="filter" class="custom-search-input" placeholder="Search for"
                                    autocomplete="off" [(ngModel)]="filterString"
                                    (ngModelChange)="onFilterChange('assets')" tabindex="1">
                            </div>
                            <div class="p-2">
                                <div class="table-responsive p-1 box-table">
                                    <table id="asset-table" class="table box-table table-borderless m-0 p-0" matSort
                                        (matSortChange)="sortAssetsData($event)" matSortActive="name"
                                        matSortDirection="asc" matSortDisableClear>
                                        <thead class="">
                                            <tr class="justify-content-center ">
                                                <th class="text-center">
                                                    <p class="m-0">#</p>
                                                </th>
                                                <th class="th-center" mat-sort-header="name">
                                                    <p class="m-0 pl-4">Assets Name</p>
                                                </th>
                                                <th class="" mat-sort-header="is_suspended">
                                                    <p class="m-0">Status</p>
                                                </th>
                                                <th class="text-center">
                                                    <p class="m-0">Action</p>
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody class="">
                                            <tr class=""
                                                *ngFor="let data of sortedAssetsData| slice: (pageA-1) * pageSizeA : pageA * pageSizeA;let i=index">
                                                <td class="text-center">
                                                    <p class="m-0 pl-2">{{i + 1 + (pageA - 1) * pageSizeA}}</p>
                                                </td>

                                                <td class="text-center">
                                                    <p class="m-0">{{data.name}}</p>
                                                </td>
                                                <td class="text-center">
                                                    <div class="row text-center" *ngIf="data.is_suspended===0">
                                                        <span class="dot-active"></span>
                                                        <p class="m-0">Active</p>
                                                    </div>
                                                    <div class="row" *ngIf="data.is_suspended===1">
                                                        <span class="dot-suspend"></span>
                                                        <p class="m-0">Suspended</p>
                                                    </div>

                                                </td>

                                                <td class="text-center">
                                                    <div class="align-items-center m-0 p-0">
                                                        <i class='fa fa-pencil-square-o light_grey fa-md mr-3  pointer'
                                                            (click)="editAssets(data.id)"> </i>
                                                        <!-- <i class='fa fa-ban fa-md light_grey mr-3 pointer' (click)="suspendAssets(data.id,data.name,data.is_suspended)"></i> -->
                                                        <i class='fa fa-trash fa-md light_grey pointer'
                                                            (click)="deleteAssets(data.id,data.name)"></i>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div class="text-center p-5"
                                        *ngIf="sortedAssetsData && sortedAssetsData.length === 0">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72"
                                            fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                            <path
                                                d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z" />
                                        </svg>
                                        <p class="m-0 no-record"> No Record Found </p>
                                    </div>


                                </div>
                                <div class="mt-3 sl-pagination text-center justify-content-center"
                                    *ngIf="sortedAssetsData">
                                    <ngb-pagination [(page)]="pageA" [rotate]="true" [ellipses]="false"
                                        [boundaryLinks]="true" [maxSize]="5" *ngIf="sortedAssetsData.length > 10"
                                        [collectionSize]="sortedAssetsData.length" aria-label="Default pagination"
                                        class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
                                </div>
                            </div>
                            <div class="text-right">
                                <button type="button" class="btn btn-danger mt-1 mr-3 btn-w"
                                    (click)="exportexcel('asset-table', 'Asset List')">Export to excel</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 m-0 p-1 grid-margin stretch-card">
                        <div class="bg-white rounded shadow pb-3">
                            <div class="title-header" *ngIf="isAddRegion">
                                <h5 class="mp-0">Add Assets</h5>
                            </div>
                            <div class="title-header" *ngIf="!isAddRegion">
                                <h5 class="mp-0">Update Assets</h5>
                            </div>

                            <form [formGroup]="assetsForm" (ngSubmit)="onAssetsSubmit()" class="p-3">
                                <div class="form-group">
                                    <label for="name">Assets Name</label>
                                    <input (keypress)="omit_special_char($event)" type="text" formControlName="name"
                                        class="form-control"
                                        [ngClass]="{ 'is-invalid': assetsSubmitted && f3.name.errors }" />
                                    <div *ngIf="assetsSubmitted && f3.name.errors" class="invalid-feedback">
                                        <div *ngIf="f3.name.errors.required">Assets Name is required</div>
                                        <div *ngIf="f3.name.errors.minlength">Assets Name should be atleast of 3
                                            character.</div>
                                    </div>
                                </div>

                                <div class="text-center mt-3">
                                    <button *ngIf="isAddAssets" class="btn btn-success mr-3 btn-w mt-2 ">Save</button>
                                    <button *ngIf="isAddAssets" class="btn btn-secondary btn-w mt-2 " type="reset"
                                        (click)="onReset()">Reset</button>
                                    <button *ngIf="!isAddAssets" class="btn btn-success mr-3 mt-2 btn-w">Update
                                        Assets</button>
                                    <button *ngIf="!isAddAssets" class="btn btn-info btn-w mt-2 " type="cancel"
                                        (click)="addNewAssets()">Add Assets</button>
                                </div>
                            </form>

                        </div>

                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="creative" role="tabpanel" aria-labelledby="creative-tab">
                <div class="row m-0 p-0 ">
                    <div class="col-lg-8 m-0 p-1 grid-margin stretch-card">
                        <div class="bg-white rounded shadow pb-3">
                            <div class="title-header">
                                <h5 class="mp-0">Creative Lists</h5>
                            </div>
                            <div class="custom-search my-auto pl-3 pt-2">
                                <input type="filter" class="custom-search-input" placeholder="Search for"
                                    autocomplete="off" [(ngModel)]="filterString"
                                    (ngModelChange)="onFilterChange('creative')" tabindex="1">
                            </div>
                            <div class="p-2">
                                <div class="table-responsive p-1 box-table">
                                    <table id="creative-table" class="table box-table table-borderless m-0 p-0" matSort
                                        (matSortChange)="sortCreativeData($event)" matSortActive="name"
                                        matSortDirection="asc" matSortDisableClear>
                                        <thead class="">
                                            <tr class="justify-content-center ">
                                                <th class="text-center">
                                                    <p class="m-0">#</p>
                                                </th>
                                                <th class="th-center" mat-sort-header="name">
                                                    <p class="m-0 pl-4">Assets Name</p>
                                                </th>
                                                <th class="" mat-sort-header="is_suspended">
                                                    <p class="m-0">Status</p>
                                                </th>
                                                <th class="text-center">
                                                    <p class="m-0">Action</p>
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody class="">
                                            <tr class=""
                                                *ngFor="let data of sortedCreativeData| slice: (pageC-1) * pageSizeC : pageC * pageSizeC;let i=index">
                                                <td class="text-center">
                                                    <p class="m-0 pl-2">{{i+1}}</p>
                                                </td>

                                                <td class="text-center">
                                                    <p class="m-0">{{data.name}}</p>
                                                </td>


                                                <td class="text-center">
                                                    <div class="row" *ngIf="data.is_suspended===0">
                                                        <span class="dot-active"></span>
                                                        <p class="m-0">Active</p>
                                                    </div>
                                                    <div class="row" *ngIf="data.is_suspended===1">
                                                        <span class="dot-suspend"></span>
                                                        <p class="m-0">Suspended</p>
                                                    </div>

                                                </td>

                                                <td class="text-center">
                                                    <div class="align-items-center m-0 p-0">
                                                        <i class='fa fa-pencil-square-o light_grey fa-md mr-3  pointer'
                                                            (click)="editCreative(data.id)"> </i>
                                                        <!-- <i class='fa fa-ban fa-md light_grey mr-3 pointer' (click)="suspendCreative(data.id,data.name,data.is_suspended)"></i> -->
                                                        <i class='fa fa-trash fa-md light_grey pointer'
                                                            (click)="deleteCreative(data.id,data.name)"></i>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div class="text-center p-5"
                                        *ngIf="sortedCreativeData && sortedCreativeData.length === 0">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72"
                                            fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                            <path
                                                d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z" />
                                        </svg>
                                        <p class="m-0 no-record"> No Record Found </p>
                                    </div>

                                </div>
                                <div class="mt-3 sl-pagination text-center justify-content-center"
                                    *ngIf="sortedCreativeData">
                                    <ngb-pagination [(page)]="pageC" [rotate]="true" [ellipses]="false"
                                        [boundaryLinks]="true" [maxSize]="5" *ngIf="sortedCreativeData.length > 10"
                                        [collectionSize]="sortedCreativeData.length" aria-label="Default pagination"
                                        class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
                                </div>
                            </div>
                            <div class="text-right">
                                <button type="button" class="btn btn-danger mt-1 mr-3 btn-w"
                                    (click)="exportexcel('creative-table', 'Creative List')">Export to excel</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 m-0 p-1 grid-margin stretch-card">
                        <div class="bg-white rounded shadow pb-3">
                            <div class="title-header" *ngIf="isAddCreative">
                                <h5 class="mp-0">Add Creative</h5>
                            </div>
                            <div class="title-header" *ngIf="!isAddCreative">
                                <h5 class="mp-0">Update Creative</h5>
                            </div>

                            <form [formGroup]="creativeForm" (ngSubmit)="onCreativeSubmit()" class="p-3">
                                <div class="form-group">
                                    <label for="name">Creative Name</label>
                                    <input (keypress)="omit_special_char($event)" type="text" formControlName="name"
                                        class="form-control"
                                        [ngClass]="{ 'is-invalid': creativeSubmitted && f4.name.errors }" />
                                    <div *ngIf="creativeSubmitted && f4.name.errors" class="invalid-feedback">
                                        <div *ngIf="f4.name.errors.required">Creative Name is required</div>
                                        <div *ngIf="f4.name.errors.minlength">Creative Name should be atleast of 2
                                            character.</div>
                                    </div>
                                </div>

                                <div class="text-center mt-3">
                                    <button *ngIf="isAddCreative" class="btn btn-success mr-3 mt-2 btn-w">Save</button>
                                    <button *ngIf="isAddCreative" class="btn btn-secondary btn-w mt-2 " type="reset"
                                        (click)="onReset()">Reset</button>
                                    <button *ngIf="!isAddCreative" class="btn btn-success mr-3 mt-2  btn-w">Update
                                        Creative</button>
                                    <button *ngIf="!isAddCreative" class="btn btn-info btn-w mt-2 " type="cancel"
                                        (click)="addNewCreative()">Add Creative</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="floor" role="tabpanel" aria-labelledby="floor-tab">
                <div class="m-0 p-0">
                    <div class="row m-0 p-0 w-100" *ngIf="!isShowAddFloor">
                        <div class="col-lg-8 m-0 p-1 grid-margin stretch-card">
                            <div class="bg-white rounded shadow pb-3">
                                <div class="title-header">
                                    <h5 class="mp-0">Floor Lists</h5>
                                </div>
                                <div class="custom-search my-auto pl-3 pt-2">
                                    <input type="filter" class="custom-search-input" placeholder="Search for"
                                        autocomplete="off" [(ngModel)]="filterString"
                                        (ngModelChange)="onFilterChange('floor')" tabindex="1">
                                </div>
                                <div class="p-2">
                                    <div class="table-responsive p-1 box-table">
                                        <table id="floor-table" class="table box-table table-borderless m-0 p-0" matSort
                                            (matSortChange)="sortFloorData($event)" matSortActive="name"
                                            matSortDirection="asc" matSortDisableClear>
                                            <thead class="">
                                                <tr class="justify-content-center ">
                                                    <th class="text-center">
                                                        <p class="m-0">#</p>
                                                    </th>
                                                    <!-- <th class="th-center" mat-sort-header = "code"><p class="m-0 pl-4">Floor Code</p></th> -->
                                                    <th class="th-center" mat-sort-header="name">
                                                        <p class="m-0 pl-4">Floor Name</p>
                                                    </th>
                                                    <th class="" mat-sort-header="is_suspended">
                                                        <p class="m-0">Status</p>
                                                    </th>
                                                    <th class="text-center">
                                                        <p class="m-0">Action</p>
                                                    </th>
                                                </tr>

                                            </thead>

                                            <tbody class="">
                                                <tr class=""
                                                    *ngFor="let data of sortedFloorData| slice: (pageF-1) * pageSizeF : pageF * pageSizeF;let i=index">
                                                    <td class="text-center">
                                                        <p class="m-0 pl-2">{{i+1}}</p>
                                                    </td>
                                                    <!-- <td class="text-center">
                                    <p class="m-0">{{data.code}}</p>
                                </td> -->
                                                    <td class="text-center">
                                                        <p class="m-0">{{data.name}}</p>
                                                    </td>
                                                    <td class="text-center">
                                                        <div class="row text-center" *ngIf="data.is_suspended===0">
                                                            <span class="dot-active"></span>
                                                            <p class="m-0">Active</p>
                                                        </div>
                                                        <div class="row" *ngIf="data.is_suspended===1">
                                                            <span class="dot-suspend"></span>
                                                            <p class="m-0">Suspended</p>
                                                        </div>

                                                    </td>

                                                    <td class="text-center">
                                                        <div class="align-items-center m-0 p-0">
                                                            <i class='fa fa-pencil-square-o light_grey fa-md mr-3  pointer'
                                                                (click)="editFloor(data.id)"> </i>
                                                            <!-- <i class='fa fa-ban fa-md light_grey mr-3 pointer' (click)="suspendFloor(data.id,data.name,data.is_suspended)"></i> -->
                                                            <i class='fa fa-trash fa-md light_grey pointer'
                                                                (click)="deleteFloor(data.id,data.name)"></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>


                                        </table>

                                        <div class="text-center p-5"
                                            *ngIf="sortedFloorData && sortedFloorData.length === 0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72"
                                                fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                                <path
                                                    d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z" />
                                            </svg>
                                            <p class="m-0 no-record"> No Record Found </p>
                                        </div>
                                    </div>
                                    <div class="mt-3 sl-pagination text-center justify-content-center"
                                        *ngIf="sortedFloorData && sortedFloorData.length > 10">
                                        <ngb-pagination [(page)]="pageF" [rotate]="true" [ellipses]="false"
                                            [boundaryLinks]="true" [maxSize]="5"
                                            [collectionSize]="sortedFloorData.length" aria-label="Default pagination"
                                            class="pagination pagination-rounded-flat pagination-success">
                                        </ngb-pagination>
                                    </div>
                                </div>
                                <div class="text-right">
                                    <button type="button" class="btn btn-danger mt-1 mr-3 btn-w"
                                        (click)="exportexcel('floor-table', 'Floor List')">Export to excel</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 m-0 p-1 grid-margin stretch-card">
                            <div class="bg-white rounded shadow pb-3">
                                <div class="title-header" *ngIf="isAddFloor">
                                    <h5 class="mp-0">Add Floor</h5>
                                </div>
                                <div class="title-header" *ngIf="!isAddFloor">
                                    <h5 class="mp-0">Update Floor</h5>
                                </div>
                                <form [formGroup]="floorForm" (ngSubmit)="onFloorSubmit()" class="p-3">
                                    <div class="form-group">
                                        <label for="name">Floor Name</label>
                                        <input (keypress)="omit_special_char($event)" type="text" formControlName="name"
                                            class="form-control"
                                            [ngClass]="{ 'is-invalid': floorSubmitted && f_floor.name.errors }" />
                                        <div *ngIf="floorSubmitted && f_floor.name.errors" class="invalid-feedback">
                                            <div *ngIf="f_floor.name.errors.required">Floor Name is required</div>
                                            <div *ngIf="f_floor.name.errors.minlength">Floor Name should be atleast of 3
                                                character.</div>
                                        </div>
                                    </div>

                                    <!-- <div class="form-group">
                        <label for="code">Floor Code</label>
                        <input type="text" formControlName="code" class="form-control" [ngClass]="{ 'is-invalid': floorSubmitted && f_floor.code.errors }" />
                        <div *ngIf="floorSubmitted && f_floor.code.errors" class="invalid-feedback">
                          <div *ngIf="f_floor.code.errors.required">Floor Code is required</div>
                          <div *ngIf="f_floor.code.errors.minlength">Floor Code should be atleast of 2 character.</div>
                        </div> 
                    </div> -->

                                    <div class="text-center mt-3">
                                        <button *ngIf="isAddFloor" class="btn btn-success mr-3 mt-2 btn-w">Save</button>
                                        <button *ngIf="isAddFloor" class="btn btn-secondary mr-3 mt-2 btn-w"
                                            type="reset" (click)="onReset()">Reset</button>
                                        <button *ngIf="isAddFloor" class="btn btn-cream btn-w mt-2 " type="reset"
                                            (click)="mapFloor()">Map Floor </button>

                                        <button *ngIf="!isAddFloor" class="btn btn-success mr-3 mt-2 btn-w">Update
                                            Floor</button>
                                        <button *ngIf="!isAddFloor" class="btn btn-info btn-w mt-2 " type="cancel"
                                            (click)="addNewFloor()">Add Floor</button>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                    <div class="row m-0 p-0 w-100" *ngIf="isShowAddFloor">
                        <div class="col-lg-8 m-0 p-1 grid-margin stretch-card">
                            <div class="bg-white rounded shadow pb-3">
                                <div class="title-header">
                                    <h5 class="mp-0">Floor Mapping Lists</h5>
                                </div>
                                <div class="custom-search my-auto pl-3 pt-2">
                                    <input type="filter" class="custom-search-input" placeholder="Search for"
                                        autocomplete="off" [(ngModel)]="filterString"
                                        (ngModelChange)="onFilterChange('floorMapping')" tabindex="1">
                                </div>
                                <div class="p-2">
                                    <div class="floor-table table-responsive p-1 box-table">
                                        <table class="table box-table table-borderless m-0 p-0" matSort
                                            (matSortChange)="sortFloorMapping($event)" matSortActive="name"
                                            matSortDirection="asc" matSortDisableClear>
                                            <thead class="">
                                                <tr class="justify-content-center ">
                                                    <th class="text-center">
                                                        <p class="m-0">#</p>
                                                    </th>
                                                    <th class="th-center" mat-sort-header="region_name">
                                                        <p class="m-0 pl-4">Region Name</p>
                                                    </th>
                                                    <th class="th-center" mat-sort-header="showroom_name">
                                                        <p class="m-0 pl-4">Showroom Name</p>
                                                    </th>
                                                    <th class="text-center">
                                                        <p class="m-0">Floors</p>
                                                    </th>
                                                    <!-- <th class="text-center"><p class="m-0">Action</p></th> -->
                                                </tr>
                                            </thead>

                                            <tbody class="">
                                                <tr class=""
                                                    *ngFor="let data of sortedMappingFloorData | slice: (pageFM-1) * pageSizeFM : pageFM * pageSizeFM;let i=index">
                                                    <td class="text-center">
                                                        <p class="m-0 pl-2">{{i+1}}</p>
                                                    </td>
                                                    <td class="text-center">
                                                        <p class="m-0">{{data.region_name}}</p>
                                                    </td>
                                                    <td class="text-center">
                                                        <p class="m-0">{{data.showroom_name}}</p>
                                                    </td>
                                                    <td class="text-center">
                                                        <p class="m-0"> {{getFloorName(data.floor_ids)}}</p>
                                                    </td>
                                                    <!-- <td class="text-center">
                                    <div class="align-items-center m-0 p-0">
                                      <i class='fa fa-pencil-square-o light_grey fa-md mr-3 pointer' (click)="getFloorName(data.floor_ids)"></i>
                                    </div>
                                  </td> -->
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div class="text-center p-5"
                                            *ngIf="sortedMappingFloorData && sortedMappingFloorData.length === 0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72"
                                                fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                                <path
                                                    d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z" />
                                            </svg>
                                            <p class="m-0 no-record"> No Record Found </p>
                                        </div>

                                    </div>
                                    <div class="mt-3 sl-pagination text-center justify-content-center"
                                        *ngIf="sortedMappingFloorData">
                                        <ngb-pagination [(page)]="pageFM" [rotate]="true" [ellipses]="false"
                                            [boundaryLinks]="true" [maxSize]="5"
                                            *ngIf="sortedMappingFloorData.length > 10"
                                            [collectionSize]="sortedMappingFloorData.length"
                                            aria-label="Default pagination"
                                            class="pagination pagination-rounded-flat pagination-success">
                                        </ngb-pagination>
                                    </div>

                                </div>
                                <div class="text-right">
                                    <button type="button" class="btn btn-danger mt-1 mr-3 btn-w"
                                        (click)="exportexcel('floor-mapping', 'Floor Mapping')">Export to excel</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 m-0 p-1 grid-margin stretch-card">
                            <div class="bg-white rounded shadow pb-3">
                                <div class="title-header" *ngIf="isAddMapFloor">
                                    <h5 class="mp-0">Floor Mapping</h5>
                                </div>
                                <div class="title-header" *ngIf="!isAddMapFloor">
                                    <h5 class="mp-0">Update Floor Mapping</h5>
                                </div>

                                <form [formGroup]="floorMappingForm" class="form-horizontal p-3"
                                    (ngSubmit)="onFloorMappingSubmit()">

                                    <div class="form-group">
                                        <label>Select Region</label>
                                        <select #region [(ngModel)]="selected_User_Region"
                                            (change)="onRegionChange(region.value,true,'')" formControlName="region_id"
                                            class="custom-select round"
                                            [ngClass]="{ 'is-invalid': floorMappingSubmitted && f_m_floor.region_id.errors }">
                                            <option value="">Select Region</option>
                                            <option *ngFor="let data of RegionDataLists" [value]=data.id>{{data.name}}
                                            </option>
                                        </select>
                                        <div *ngIf="floorMappingSubmitted && f_m_floor.region_id.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="f_m_floor.region_id.errors.required">Region is required</div>
                                        </div>

                                    </div>

                                    <div class="form-group">
                                        <label>Select Showroom</label>
                                        <select #showroom [(ngModel)]="selected_User_Showroom"
                                            (change)="onShowroomChange(showroom.value)" formControlName="showroom_id"
                                            class="custom-select round"
                                            [ngClass]="{ 'is-invalid': floorMappingSubmitted && f_m_floor.showroom_id.errors }">
                                            <option value="">Select Showroom</option>
                                            <option *ngFor="let data of f_user_ShowroomLists" [value]=data.id>
                                                {{data.name}}</option>
                                        </select>
                                        <div *ngIf="floorMappingSubmitted && f_m_floor.showroom_id.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="f_m_floor.showroom_id.errors.required">Region is required</div>
                                        </div>

                                    </div>

                                    <label class="label-header">Select Floors</label>
                                    <div class="floor-lists">
                                        <div class="form-group">
                                            <div class="item-checkbox" *ngFor="let item of FloorDataLists">
                                                <label><input type="checkbox" [checked]="item.isSelected"
                                                        name="floor_id" (change)="setChecked(item.id)" tabindex="0"
                                                        class="hidden"> {{item.name}}</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="box-table">
                                        <div class="text-center p-5"
                                            *ngIf="FloorDataLists && FloorDataLists.length === 0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48"
                                                fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                                <path
                                                    d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z" />
                                            </svg>
                                            <p class="m-0 no-record"> No Record Found </p>
                                        </div>

                                    </div>

                                    <div class="text-center mt-3">
                                        <button class="btn btn-success mr-3 mt-2 btn-w">Save</button>
                                        <button class="btn btn-secondary mr-3 mt-2 btn-w" type="reset"
                                            (click)="onReset()">Reset</button>
                                        <button class="btn btn-cream btn-w mt-2 " type="cancel"
                                            (click)="addNewFloor()">Add Floor</button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="location" role="tabpanel" aria-labelledby="location-tab">
                <div class="">
                    <div class="row m-0 p-0" *ngIf="isShowAddLocation">
                        <div class="col-lg-8 m-0 p-1 grid-margin stretch-card">
                            <div class="bg-white rounded shadow pb-3">
                                <div class="title-header">
                                    <h5 class="mp-0">Location Lists</h5>
                                </div>
                                <div class="custom-search my-auto pl-3 pt-2">
                                    <input type="filter" class="custom-search-input" placeholder="Search for"
                                        autocomplete="off" [(ngModel)]="filterString"
                                        (ngModelChange)="onFilterChange('location')" tabindex="1">
                                </div>
                                <div class="p-2">
                                    <div class="table-responsive p-1 box-table">
                                        <table id="location-table" class="table box-table table-borderless m-0 p-0"
                                            matSort (matSortChange)="sortLocationData($event)" matSortActive="name"
                                            matSortDirection="asc" matSortDisableClear>
                                            <thead class="">
                                                <tr class="justify-content-center ">
                                                    <th class="text-center">
                                                        <p class="m-0">#</p>
                                                    </th>
                                                    <th class="th-center" mat-sort-header="name">
                                                        <p class="m-0 pl-4">Location Name</p>
                                                    </th>
                                                    <th class="" mat-sort-header="is_suspended">
                                                        <p class="m-0">Status</p>
                                                    </th>
                                                    <th class="text-center">
                                                        <p class="m-0">Action</p>
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody class="">
                                                <tr class=""
                                                    *ngFor="let data of sortedLocationData| slice: (pageL-1) * pageSizeL : pageL * pageSizeL;let i=index">
                                                    <td class="text-center">
                                                        <p class="m-0 pl-2">{{i+1}}</p>
                                                    </td>
                                                    <td class="text-center">
                                                        <p class="m-0">{{data.name}}</p>
                                                    </td>
                                                    <td class="text-center">
                                                        <div class="row text-center" *ngIf="data.is_suspended===0">
                                                            <span class="dot-active"></span>
                                                            <p class="m-0">Active</p>
                                                        </div>
                                                        <div class="row" *ngIf="data.is_suspended===1">
                                                            <span class="dot-suspend"></span>
                                                            <p class="m-0">Suspended</p>
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        <div class="align-items-center m-0 p-0">
                                                            <i class='fa fa-pencil-square-o light_grey fa-md mr-3  pointer'
                                                                (click)="editLocation(data.id)"> </i>
                                                            <!-- <i class='fa fa-ban fa-md light_grey mr-3 pointer' (click)="suspendLocation(data.id,data.name,data.is_suspended)"></i> -->
                                                            <i class='fa fa-trash fa-md light_grey pointer'
                                                                (click)="deleteLocation(data.id,data.name)"></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="text-center p-5"
                                            *ngIf="sortedLocationData && sortedLocationData.length === 0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72"
                                                fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                                <path
                                                    d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z" />
                                            </svg>
                                            <p class="m-0 no-record"> No Record Found </p>
                                        </div>
                                    </div>
                                    <div class="mt-3 sl-pagination text-center justify-content-center"
                                        *ngIf="sortedLocationData">
                                        <ngb-pagination [(page)]="pageL" [maxSize]="5" [rotate]="true"
                                            [ellipses]="false" [boundaryLinks]="true"
                                            *ngIf="sortedLocationData.length > 10"
                                            [collectionSize]="sortedLocationData.length" aria-label="Default pagination"
                                            class="pagination pagination-rounded-flat pagination-success">
                                        </ngb-pagination>
                                    </div>
                                </div>
                                <div class="text-right">
                                    <button type="button" class="btn btn-danger mt-1 mr-3 btn-w"
                                        (click)="exportexcel('location-table', 'Location List')">Export to
                                        excel</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 m-0 p-1 grid-margin stretch-card">
                            <div class="bg-white rounded shadow pb-3">


                                <div class="title-header" *ngIf="isAddLocation">
                                    <h5 class="mp-0">Add Location</h5>
                                </div>
                                <div class="title-header" *ngIf="!isAddLocation">
                                    <h5 class="mp-0">Update Location</h5>
                                </div>


                                <form [formGroup]="locationForm" (ngSubmit)="onLocationSubmit()" class="p-3">
                                    <div class="form-group">
                                        <label for="name">Location Name</label>
                                        <input (keypress)="omit_special_char($event)" type="text" formControlName="name"
                                            class="form-control"
                                            [ngClass]="{ 'is-invalid': locationSubmitted && f_location.name.errors }" />
                                        <div *ngIf="locationSubmitted && f_location.name.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="f_location.name.errors.required">Location Name is required</div>
                                            <div *ngIf="f_location.name.errors.minlength">Location Name should be
                                                atleast of 3 character.</div>
                                        </div>
                                    </div>

                                    <div class="text-center mt-3">
                                        <button *ngIf="isAddLocation"
                                            class="btn btn-success mr-3 mt-2 btn-w">Save</button>
                                        <button *ngIf="isAddLocation" class="btn btn-secondary mr-3 mt-2 btn-w"
                                            type="reset" (click)="onReset()">Reset</button>
                                        <button *ngIf="isAddLocation" class="btn btn-cream btn-w mt-2 " type="reset"
                                            (click)="mapLocation()">Map Location </button>

                                        <button *ngIf="!isAddLocation" class="btn btn-success mr-3 mt-2 btn-w">Update
                                            Location</button>
                                        <button *ngIf="!isAddLocation" class="btn btn-info btn-w mt-2 " type="cancel"
                                            (click)="addNewLocation()">Add Location</button>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                    <div class="row m-0 p-0" *ngIf="!isShowAddLocation">
                        <div class="col-lg-8 m-0 p-1 grid-margin stretch-card">
                            <div class="bg-white rounded shadow pb-3">
                                <div class="title-header">
                                    <h5 class="mp-0">Location Mapping Lists</h5>
                                </div>
                                <form [formGroup]="filterform">
                                    <div class="row m-0 p-1 w-100 d-flex">
                                        <div class="col-sm-4 m-0 p-1">
                                            <div class="form-group">
                                                <label>Region:</label>
                                                <select #region_ class="custom-select round" formControlName="region_id"
                                                    (change)="onFilterRegionChange(region_.value)">
                                                    <option value="">Select Region</option>
                                                    <option *ngFor="let data of RegionDataLists" [value]="data.id">
                                                        {{data.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 m-0 p-1">
                                            <div class="form-group">
                                                <label>Showroom:</label>
                                                <select #showroom_ class="custom-select round"
                                                    formControlName="showroom_id"
                                                    (change)="onFilterShowroomChange(showroom_.value)">
                                                    <option value="">Select Showroom</option>
                                                    <option *ngFor="let data of location_f_showroomLists"
                                                        [value]="data.id">{{data.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 m-0 p-1">
                                            <div class="form-group">
                                                <label>Floor:</label>
                                                <select #floor_ class="custom-select round" formControlName="floor_id"
                                                    (change)="onFilterFloorChange(floor_.value)">
                                                    <option value="">Select Floor</option>
                                                    <option *ngFor="let data of location_f_FloorLists"
                                                        [value]="data.id">{{data.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div class="p-2">
                                    <div class="location-table table-responsive p-1 box-table">
                                        <table table id="location-mapping"
                                            class="table box-table table-borderless m-0 p-0" matSort
                                            (matSortChange)="sortLocationMapping($event)" matSortActive="name"
                                            matSortDirection="asc" matSortDisableClear>
                                            <thead class="">
                                                <tr class="justify-content-center ">
                                                    <th class="text-center">
                                                        <p class="m-0">#</p>
                                                    </th>
                                                    <th class="th-center" mat-sort-header="region_name">
                                                        <p class="m-0 pl-4">Region Name</p>
                                                    </th>
                                                    <th class="th-center" mat-sort-header="showroom_name">
                                                        <p class="m-0 pl-4">Showroom Name</p>
                                                    </th>
                                                    <th class="text-center">
                                                        <p class="m-0">Floor</p>
                                                    </th>
                                                    <th class="text-center">
                                                        <p class="m-0">Location</p>
                                                    </th>
                                                    <!-- <th class="text-center"><p class="m-0">Action</p></th> -->
                                                </tr>
                                            </thead>
                                            <tbody class="">
                                                <tr class=""
                                                    *ngFor="let data of LocationMappingDataLists | slice: (page-1) * pageSize : page * pageSize;let i=index">
                                                    <td class="text-center">
                                                        <p class="m-0 pl-2">{{i+1}}</p>
                                                    </td>
                                                    <td class="text-center">
                                                        <p class="m-0">{{data.region_name}}</p>
                                                    </td>
                                                    <td class="text-center">
                                                        <p class="m-0">{{data.showroom_name}}</p>
                                                    </td>
                                                    <td class="text-center">
                                                        <p class="m-0">{{data.floor_name}}</p>
                                                    </td>
                                                    <td class="text-center">
                                                        <p class="m-0"> {{getLocationName(data.location_ids)}}</p>
                                                    </td>
                                                    <!-- <td class="text-center">
                                        <div class="align-items-center m-0 p-0">
                                          <i class='fa fa-pencil-square-o light_grey fa-md mr-3 pointer'></i>
                                        </div>
                                      </td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="text-center p-5"
                                            *ngIf="LocationMappingDataLists && LocationMappingDataLists.length === 0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72"
                                                fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                                <path
                                                    d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z" />
                                            </svg>
                                            <p class="m-0 no-record"> No Record Found </p>
                                        </div>
                                    </div>
                                    <!-- <div class="mt-3 sl-pagination text-center justify-content-center" *ngIf="LocationMappingDataLists">
                          <ngb-pagination  [(page)]="page"
                          [pageSize]="pageSize"   [maxSize]="5"
                          *ngIf="LocationMappingDataLists.length > 10"
                          [collectionSize]="LocationMappingDataLists.length" aria-label="Default pagination" class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
                        </div> -->

                                </div>
                                <div class="text-right">
                                    <button type="button" class="btn btn-danger mt-1 mr-3 btn-w"
                                        (click)="exportexcel('location-mapping', 'Location Mapping')">Export to
                                        excel</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 m-0 p-1 grid-margin stretch-card">
                            <div class="bg-white rounded shadow pb-3">
                                <div class="title-header">
                                    <h5 class="mp-0">Location Mapping</h5>
                                </div>
                                <form [formGroup]="locationMappingForm" class="form-horizontal p-3"
                                    (ngSubmit)="onLocationMappingSubmit()">

                                    <div class="form-group">
                                        <label>Select Region</label>

                                        <select #region [(ngModel)]="selected_User_Region"
                                            (change)="onRegionChange(region.value,true,'')" formControlName="region_id"
                                            class="custom-select round"
                                            [ngClass]="{ 'is-invalid': locationMappingSubmitted && loc_map_form.region_id.errors }">
                                            <option value="">Select Region</option>
                                            <option *ngFor="let data of RegionDataLists" [value]=data.id>{{data.name}}
                                            </option>
                                        </select>
                                        <div *ngIf="locationMappingSubmitted && loc_map_form.region_id.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="loc_map_form.region_id.errors.required">Region is required</div>
                                        </div>


                                    </div>

                                    <div class="form-group">
                                        <label>Select Showroom</label>
                                        <select #showroom [(ngModel)]="selected_User_Showroom"
                                            (change)="getFloorfromShowroom(showroom.value)"
                                            formControlName="showroom_id" class="custom-select round"
                                            [ngClass]="{ 'is-invalid': locationMappingSubmitted && loc_map_form.showroom_id.errors }">
                                            <option value="">Select Showroom</option>
                                            <option *ngFor="let data of f_user_ShowroomLists" [value]=data.id>
                                                {{data.name}}</option>
                                        </select>
                                        <div *ngIf="locationMappingSubmitted && loc_map_form.showroom_id.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="loc_map_form.showroom_id.errors.required">Region is required
                                            </div>
                                        </div>
                                    </div>


                                    <div class="form-group">
                                        <label>Select Floor</label>
                                        <select #floor [(ngModel)]="selected_User_Floor" formControlName="floor_id"
                                            class="custom-select round"
                                            [ngClass]="{ 'is-invalid': locationMappingSubmitted && loc_map_form.floor_id.errors }"
                                            (change)="onFloorSelectionChange(floor.value)">
                                            <option value="">Select Floor</option>
                                            <option *ngFor="let data of ShowroomFloorDataLists" [value]=data.id>
                                                {{data.name}}</option>
                                        </select>

                                        <div *ngIf="locationMappingSubmitted && loc_map_form.floor_id.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="loc_map_form.floor_id.errors.required">Floor is required</div>
                                        </div>
                                    </div>

                                    <label class="label-header">Select Locations</label>
                                    <div class="custom-search my-auto search-block d-flex pt-2">
                                        <input type="filter" class="custom-search-input location-search"
                                            placeholder="Search for" autocomplete="off" [(ngModel)]="filterString"
                                            (input)="onFilterChange('locate',$event.target.value)" tabindex="1">
                                    </div>
                                    <div class="loc-lists">
                                        <div class="form-group">
                                            <div class="item-checkbox" *ngFor="let item of filterLocationList">
                                                <label><input type="checkbox" [checked]="item.isSelected"
                                                        name="location_id" id="location_id" tabindex="0" class="hidden"
                                                        (change)="setLocationChecked(item.id)"> {{item.name}}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="box-table">
                                        <div class="text-center p-5"
                                            *ngIf="filterLocationList && filterLocationList.length === 0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48"
                                                fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                                <path
                                                    d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z" />
                                            </svg>
                                            <p class="m-0 no-record"> No Record Found </p>
                                        </div>

                                    </div>

                                    <div class="text-center mt-3">
                                        <button class="btn btn-success mr-3 mt-2 btn-w">Save</button>
                                        <button class="btn btn-secondary mr-3 mt-2 btn-w" type="reset"
                                            (click)="onReset()">Reset</button>
                                        <button class="btn btn-cream btn-w mt-2 " type="cancel"
                                            (click)="addNewLocation()">Add Location</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="vendor" role="tabpanel" aria-labelledby="vendor-tab">
                <div class="row m-0 p-0">
                    <div class="col-lg-8 m-0 p-1 grid-margin stretch-card">
                        <div class="bg-white rounded shadow pb-3">
                            <div class="title-header">
                                <h5 class="mp-0">Vendor Lists</h5>
                            </div>
                            <div class="custom-search my-auto pl-3 pt-2">
                                <input type="filter" class="custom-search-input" placeholder="Search for"
                                    autocomplete="off" [(ngModel)]="filterString"
                                    (ngModelChange)="onFilterChange('vendor')" tabindex="1">
                            </div>
                            <div class="p-2">
                                <div class="table-responsive p-1 box-table">
                                    <table id="vendor-table" class="table box-table table-borderless m-0 p-0" matSort
                                        (matSortChange)="sortVendorData($event)" matSortActive="name"
                                        matSortDirection="asc" matSortDisableClear>
                                        <thead class="">
                                            <tr class="justify-content-center ">
                                                <th class="text-center">
                                                    <p class="m-0">#</p>
                                                </th>
                                                <th class="th-center" mat-sort-header="name">
                                                    <p class="m-0 pl-4">Vendor Name</p>
                                                </th>
                                                <th class="" mat-sort-header="is_suspended">
                                                    <p class="m-0">Status</p>
                                                </th>
                                                <th class="text-center">
                                                    <p class="m-0">Action</p>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody class="">
                                            <tr class=""
                                                *ngFor="let data of sortedVendorData| slice: (pageV-1) * pageSizeV : pageV * pageSizeV;let i=index">
                                                <td class="text-center">
                                                    <p class="m-0 pl-2">{{i+1}}</p>
                                                </td>

                                                <td class="text-center">
                                                    <p class="m-0">{{data.name}}</p>
                                                </td>
                                                <td class="text-center">
                                                    <div class="row" *ngIf="data.is_suspended===0">
                                                        <span class="dot-active"></span>
                                                        <p class="m-0">Active</p>
                                                    </div>
                                                    <div class="row" *ngIf="data.is_suspended===1">
                                                        <span class="dot-suspend"></span>
                                                        <p class="m-0">Suspended</p>
                                                    </div>

                                                </td>

                                                <td class="text-center">
                                                    <div class="align-items-center m-0 p-0">
                                                        <i class='fa fa-pencil-square-o light_grey fa-md mr-3  pointer'
                                                            (click)="editVendor(data.id)"> </i>
                                                        <!-- <i class='fa fa-ban fa-md light_grey mr-3 pointer' (click)="suspendVendor(data.id,data.name,data.is_suspended)"></i> -->
                                                        <i class='fa fa-trash fa-md light_grey pointer'
                                                            (click)="deleteVendor(data.id,data.name)"></i>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div class="text-center p-5"
                                        *ngIf="sortedVendorData && sortedVendorData.length === 0">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72"
                                            fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                            <path
                                                d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z" />
                                        </svg>
                                        <p class="m-0 no-record"> No Record Found </p>
                                    </div>
                                </div>
                                <div class="mt-3 sl-pagination text-center justify-content-center"
                                    *ngIf="sortedVendorData">
                                    <ngb-pagination [(page)]="pageV" [rotate]="true" [ellipses]="false"
                                        [boundaryLinks]="true" [maxSize]="5" *ngIf="sortedVendorData.length > 10"
                                        [collectionSize]="sortedVendorData.length" aria-label="Default pagination"
                                        class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
                                </div>

                            </div>
                            <div class="text-right">
                                <button type="button" class="btn btn-danger mt-1 mr-3 btn-w"
                                    (click)="exportexcel('vendor-table', 'Vendor List')">Export to excel</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 m-0 p-1 grid-margin stretch-card">
                        <div class="bg-white rounded shadow pb-3">
                            <div class="title-header" *ngIf="isAddVendor">
                                <h5 class="mp-0">Add Vendor</h5>
                            </div>
                            <div class="title-header" *ngIf="!isAddVendor">
                                <h5 class="mp-0">Update Vendor</h5>
                            </div>
                            <form [formGroup]="vendorForm" (ngSubmit)="onVendorSubmit()" class="p-3">

                                <div class="form-group">
                                    <label for="name">Vendor Name</label>
                                    <input (keypress)="omit_special_char($event)" type="text" formControlName="name"
                                        class="form-control"
                                        [ngClass]="{ 'is-invalid': vendorSubmitted && fVendor.name.errors }" />
                                    <div *ngIf="vendorSubmitted && fVendor.name.errors" class="invalid-feedback">
                                        <div *ngIf="fVendor.name.errors.required">Vendor Name is required</div>
                                        <div *ngIf="fVendor.name.errors.minlength">Vendor Name should be atleast of 3
                                            character.</div>
                                    </div>
                                </div>

                                <div class="text-center mt-3">
                                    <button *ngIf="isAddVendor" class="btn btn-success mr-3 mt-2 btn-w">Save</button>
                                    <button *ngIf="isAddVendor" class="btn btn-secondary mt-2 btn-w" type="reset"
                                        (click)="onReset()">Reset</button>
                                    <button *ngIf="!isAddVendor" class="btn btn-success mr-3 mt-2 btn-w">Update
                                        Creative</button>
                                    <button *ngIf="!isAddVendor" class="btn btn-info btn-w mt-2" type="cancel"
                                        (click)="addNewVendor()">Add Vendor</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="user" role="tabpanel" aria-labelledby="user-tab">
                <div class="row m-0 p-0">
                    <div class="col-lg-12 m-0 p-0 grid-margin stretch-card">
                        <div class="bg-white rounded shadow mt-1 pb-3">
                            <div class="title-header">
                                <h5 class="mp-0">User Lists</h5>
                            </div>
                            <div class="custom-search my-auto pl-3 pt-2">
                                <input type="filter" class="custom-search-input" placeholder="Search for"
                                    autocomplete="off" [(ngModel)]="filterString"
                                    (ngModelChange)="onFilterChange('user')" tabindex="1">
                            </div>
                            <div class="p-2">
                                <div class="table-responsive p-1 box-table">
                                    <table id="user-table" class="table box-table table-borderless m-0 p-0" matSort
                                        (matSortChange)="sortData($event)" matSortActive="name" matSortDirection="asc"
                                        matSortDisableClear>
                                        <thead class="">
                                            <tr class="justify-content-center ">
                                                <th class="text-center">
                                                    <p class="m-0">#</p>
                                                </th>
                                                <th class="" mat-sort-header="first_name">
                                                    <p class="m-0 pl-4">Employee Name</p>
                                                </th>
                                                <th class="" mat-sort-header="role_id">
                                                    <p class="m-0">Designation</p>
                                                </th>
                                                <th class="th-center" mat-sort-header="region_id">
                                                    <p class="m-0"> Region</p>
                                                </th>
                                                <th class="th-center" mat-sort-header="showroom_id">
                                                    <p class="m-0"> Showroom</p>
                                                </th>
                                                <th class="text-center">
                                                    <p class="m-0">Email</p>
                                                </th>
                                                <th class="text-center">
                                                    <p class="m-0"> Mobile Number</p>
                                                </th>
                                                <th class="" mat-sort-header="is_suspended">
                                                    <p class="m-0">Status</p>
                                                </th>
                                                <th *ngIf="LoggedUser.role_id==1" class="text-center">
                                                    <p class="m-0">Action</p>
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody class="">
                                            <tr class=""
                                                *ngFor="let data of sortedUserData | slice: (page-1) * pageSize : page * pageSize;let i=index">
                                                <td class="text-center">
                                                    <p class="m-0 pl-2">{{i+1}}</p>
                                                </td>
                                                <td class="">
                                                    <div class="pl-4 media align-items-center m-0 p-0">
                                                        <img alt="" onerror="this.src='/assets/images/faces/dummy.png'"
                                                            src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.profile_picture}}"
                                                            class="avatar rounded-circle mr-3 pointer">
                                                        <div class="media-body">
                                                            <p class="m-0 p-0 txt-black">{{data.first_name}}
                                                                {{data.last_name}}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="">
                                                    <p class="m-0">{{data.roleName}} <i *ngIf="data.is_view==1"
                                                            class=" m-2 fa fa-eye fa-sm" aria-hidden="true"></i></p>
                                                </td>
                                                <td class="text-center">
                                                    <p class="m-0">{{data.region_id== 0 ?"All Region":data.regionName}}
                                                    </p>
                                                </td>
                                                <td class="text-center">
                                                    <p class="m-0">{{data.showroom_id== 0 ?"All
                                                        Showroom":data.showroomName}}</p>
                                                </td>
                                                <td class="text-center">
                                                    <p class="m-0">{{data.email}}</p>
                                                </td>
                                                <td class="text-center">
                                                    <p class="m-0">{{data.mobile}}</p>
                                                </td>
                                                <td class="text-center">
                                                    <div class="row" *ngIf="data.is_suspended===0">
                                                        <span class="dot-active"></span>
                                                        <p class="m-0">Active</p>
                                                    </div>
                                                    <div class="row" *ngIf="data.is_suspended===1">
                                                        <span class="dot-suspend"></span>
                                                        <p class="m-0">Suspended</p>
                                                    </div>
                                                </td>
                                                <td *ngIf="LoggedUser.role_id==1" class="text-center">
                                                    <div class="align-items-center m-0 p-0"
                                                        >
                                                        <!-- <i class="fa fa-unlock-alt  light_grey fa-md mr-3 pointer" aria-hidden="true" (click)="editUser(data,data.id)"></i> -->
                                                        <i class='fa fa-pencil-square-o light_grey fa-md mr-3  pointer'
                                                            (click)="editUser(data,data.id)"> </i>
                                                        <i class='fa fa-ban fa-md light_grey pointer'
                                                            (click)="suspendUser(data.id,data.first_name,data.is_suspended)"></i>
                                                        <i *ngIf="LoggedUser.role_id==1" class='fa fa-trash fa-md light_grey pointer'
                                                            (click)="deleteUser(data)"></i>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div class="text-center p-5" *ngIf="sortedUserData && sortedUserData.length === 0">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72"
                                            fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                            <path
                                                d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z" />
                                        </svg>
                                        <p class="m-0 no-record"> No Record Found </p>
                                    </div>
                                </div>

                                <div *ngIf="sortedUserData && sortedUserData.length > 0"
                                    class="m-3 sl-pagination text-center justify-content-center d-flex">
                                    <ngb-pagination [(page)]="page" [maxSize]="5" [rotate]="true" [ellipses]="false"
                                        [boundaryLinks]="true" [collectionSize]="sortedUserData.length"
                                        aria-label="Default pagination"
                                        class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
                                </div>
                            </div>
                            <div class="text-right">
                                <button type="button" class="btn btn-danger mt-1 mr-3 btn-w"
                                    (click)="exportexcel('user-table', 'User List')">Export to excel</button>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="col-lg-12 mp-0 grid-margin stretch-card">
                        <div class="bg-white rounded shadow mt-1 pb-3">
                            <div class="title-header">
                                <h5 class="mp-0" *ngIf="isAddUser">Add User</h5>
                                <h5 class="mp-0" *ngIf="!isAddUser">Update User</h5>
                            </div>
                            <form [formGroup]="registerForm" *ngIf="isAddUser" (ngSubmit)="onRegisterSubmit()">
                                <fieldset>
                                    <div class="row mp-0 w-100">
                                        <div class="col-lg-8 mp-0">


                                            <div class="form-row m-0 p-0">
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>Select Designation</label>
                                                        <select #designation [(ngModel)]="selectedDesignationValue"
                                                            class="custom-select round" formControlName="role_id"
                                                            [value]='' (change)="onUserRoleChange(designation.value)"
                                                            [ngClass]="{ 'is-invalid': submitted && formR.role_id.errors }">
                                                            <option value="">Select Designation</option>
                                                            <option *ngFor="let data of RoleDataLists"
                                                                [disabled]="!data.isEnabled" [value]="data.id">
                                                                {{data.name}}</option>
                                                        </select>
                                                        <div *ngIf="submitted && formR.role_id.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formR.role_id.errors.required">Designation is
                                                                required</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 p-2 grt-include my-auto">
                                                    <div class="row m-0 p-2" *ngIf="isAdmin">
                                                        <input type="checkbox" id="todo" [(ngModel)]="isViewChecked"
                                                            formControlName="isView" name="todo" value="todo" class="">
                                                        <label class="m-0 pl-1" for="todo" data-content="Only View">Only
                                                            View</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-row m-0 p-0">
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>Region:</label>
                                                        <select #region [(ngModel)]="selected_User_Region"
                                                            class="custom-select round" formControlName="region_id"
                                                            (change)="onUserRegionChange(region.value,true,'')"
                                                            [ngClass]="{ 'is-invalid': submitted && formR.region_id.errors }">
                                                            <option value="">{{default_region_txt}}</option>
                                                            <option *ngFor="let data of RegionDataLists"
                                                                [value]="data.id">{{data.name}}</option>
                                                        </select>

                                                        <div *ngIf="submitted && formR.region_id.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formR.region_id.errors.required">Region is
                                                                required</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">

                                                        <label>Showroom:</label>
                                                        <select [(ngModel)]="selected_User_Showroom"
                                                            class="custom-select round" formControlName="showroom_id"
                                                            [ngClass]="{ 'is-invalid': submitted && formR.showroom_id.errors }">
                                                            <option value="">{{default_showroom_txt}}</option>
                                                            <option *ngFor="let data of f_user_ShowroomLists"
                                                                [ngValue]="data.id">{{data.name}}</option>
                                                        </select>
                                                        <div *ngIf="submitted && formR.showroom_id.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formR.showroom_id.errors.required">Showroom is
                                                                required</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-row m-0 p-0">
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>First Name</label>
                                                        <input (keypress)="omit_special_char($event)" type="text"
                                                            formControlName="firstName" class="form-control"
                                                            [ngClass]="{ 'is-invalid': submitted && formR.firstName.errors }" />
                                                        <div *ngIf="submitted && formR.firstName.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formR.firstName.errors.required">First Name is
                                                                required</div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>Last Name</label>
                                                        <input (keypress)="omit_special_char($event)" type="text"
                                                            formControlName="lastName" class="form-control"
                                                            [ngClass]="{ 'is-invalid': submitted && formR.lastName.errors }" />
                                                        <div *ngIf="submitted && formR.lastName.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formR.lastName.errors.required">Last Name is
                                                                required</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-row m-0 p-0">
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>Email</label>
                                                        <input type="text" formControlName="email" class="form-control"
                                                            [ngClass]="{ 'is-invalid': submitted && formR.email.errors }" />
                                                        <div *ngIf="submitted && formR.email.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formR.email.errors.required">Email is required
                                                            </div>
                                                            <div *ngIf="formR.email.errors.email">Email must be a valid
                                                                email address</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>Mobile Number</label>
                                                        <input type="number" formControlName="mobile"
                                                            class="form-control"
                                                            [ngClass]="{ 'is-invalid': submitted && formR.mobile.errors }" />
                                                        <div *ngIf="submitted && formR.mobile.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formR.mobile.errors.required">Mobile Number is
                                                                required</div>

                                                            <div *ngIf="formR.mobile.errors.pattern">Mobile Number must be a valid
                                                                </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="form-row m-0 p-0" *ngIf="isAddUser">
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>Password</label>
                                                        <input type="password" formControlName="password"
                                                            class="form-control"
                                                            [ngClass]="{ 'is-invalid': submitted && formR.password.errors }" />
                                                        <div *ngIf="submitted && formR.password.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formR.password.errors.required">Password is
                                                                required</div>
                                                            <div *ngIf="formR.password.errors.minlength">Password must
                                                                be at least 6 characters</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>Confirm Password</label>
                                                        <input type="password" formControlName="confirmPassword"
                                                            class="form-control"
                                                            [ngClass]="{ 'is-invalid': submitted && formR.confirmPassword.errors }" />
                                                        <div *ngIf="submitted && formR.confirmPassword.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formR.confirmPassword.errors.required">Confirm
                                                                Password is required</div>
                                                            <div
                                                                *ngIf="formR.confirmPassword.errors.confirmedValidator">
                                                                Passwords must match</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="form-group">
                                                <label class="label-header">Profile Image:</label>
                                                <div class="uploader">

                                                    <input id="file-upload-profile" type="file" name="fileUpload"
                                                        accept="image/*" (change)="onProfileFileChange($event)" />

                                                    <label for="file-upload-profile" id="file-drag">
                                                        <img [src]="profileImage" *ngIf="profileImage"
                                                            onerror="this.src='/assets/grt.svg'" id="file-image">
                                                        <div id="start" *ngIf="!profileImage">
                                                            <img src="assets/profile-placeholder.png" id="icon"
                                                                alt="" />
                                                            <!-- <i class="fa fa-download" aria-hidden="true"></i> -->
                                                            <div class="label-header">Select a Picture</div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-center mt-3">
                                        <button *ngIf="isAddUser" class="btn btn-danger mr-3 btn-w">Register</button>
                                        <button *ngIf="isAddUser" class="btn btn-secondary btn-w" type="reset"
                                            (click)="onReset()">Reset</button>
                                        <!-- <button  *ngIf="!isAddUser" class="btn btn-success mr-3 btn-w">Update</button>
                      <button  *ngIf="!isAddUser" class="btn btn-info btn-w" type="cancel" (click)="addNewUser()">Add User</button>  -->
                                    </div>
                                </fieldset>
                            </form>


                            <form [formGroup]="updateForm" *ngIf="!isAddUser" (ngSubmit)="onUserUpdate()">
                                <fieldset>
                                    <div class="row mp-0 w-100">
                                        <div class="col-lg-8 mp-0">

                                            <div class="form-row m-0 p-0">
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>Select Designation</label>
                                                        <select #designation class="custom-select round"
                                                            formControlName="role_id"
                                                            (change)="onUserRoleUpdate(designation.value)"
                                                            [ngClass]="{ 'is-invalid': submitted && formU.role_id.errors }">
                                                            <option value="">Select Designation</option>
                                                            <option *ngFor="let data of RoleDataLists"
                                                                [value]="data.id">{{data.name}}</option>
                                                        </select>
                                                        <div *ngIf="submitted && formU.role_id.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formU.role_id.errors.required">Designation is
                                                                required</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 p-2 grt-include  my-auto">
                                                    <div class="row m-0 p-2" *ngIf="isAdmin">
                                                        <input type="checkbox" id="todo" [(ngModel)]="isView_"
                                                            formControlName="isView" name="todo" value="todo" class="">
                                                        <label class="m-0 pl-1" for="todo" data-content="Only View">Only
                                                            View</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row m-0 p-0">
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>Region:</label>
                                                        <select #region class="custom-select round"
                                                            formControlName="region_id"
                                                            (change)="onUserRegionChange(region.value,true,'')"
                                                            [ngClass]="{ 'is-invalid': submitted && formU.region_id.errors }">
                                                            <option value="">{{default_region_txt}}</option>
                                                            <option *ngFor="let data of RegionDataLists"
                                                                [value]="data.id">{{data.name}}</option>
                                                        </select>
                                                        <div *ngIf="submitted && formU.region_id.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formU.region_id.errors.required">Region is
                                                                required</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">

                                                        <label>Showroom:</label>
                                                        <select class="custom-select round"
                                                            formControlName="showroom_id"
                                                            [ngClass]="{ 'is-invalid': submitted && formU.showroom_id.errors }">
                                                            <option value="">{{default_showroom_txt}}</option>
                                                            <option *ngFor="let data of f_user_ShowroomLists"
                                                                [ngValue]="data.id">{{data.name}}</option>
                                                        </select>
                                                        <div *ngIf="submitted && formU.showroom_id.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formU.showroom_id.errors.required">Showroom is
                                                                required</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-row m-0 p-0">
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>First Name</label>
                                                        <input (keypress)="omit_special_char($event)" type="text"
                                                            formControlName="firstName" class="form-control"
                                                            [ngClass]="{ 'is-invalid': submitted && formU.firstName.errors }" />
                                                        <div *ngIf="submitted && formU.firstName.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formU.firstName.errors.required">First Name is
                                                                required</div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>Last Name</label>
                                                        <input (keypress)="omit_special_char($event)" type="text"
                                                            formControlName="lastName" class="form-control"
                                                            [ngClass]="{ 'is-invalid': submitted && formU.lastName.errors }" />
                                                        <div *ngIf="submitted && formU.lastName.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formU.lastName.errors.required">Last Name is
                                                                required</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-row m-0 p-0">
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>Email</label>
                                                        <input type="text" formControlName="email" class="form-control"
                                                            [ngClass]="{ 'is-invalid': submitted && formU.email.errors }" />
                                                        <div *ngIf="submitted && formU.email.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formU.email.errors.required">Email is required
                                                            </div>
                                                            <div *ngIf="formU.email.errors.email">Email must be a valid
                                                                email address</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>Mobile Number</label>
                                                        <input type="number" formControlName="mobile"
                                                            class="form-control"
                                                            [ngClass]="{ 'is-invalid': submitted && formU.mobile.errors }" />
                                                        <div *ngIf="submitted && formU.mobile.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formU.mobile.errors.required">Mobile Number is
                                                                required</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="form-row m-0 p-0" *ngIf="isAddUser">
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>Password</label>
                                                        <input type="password" formControlName="password"
                                                            class="form-control"
                                                            [ngClass]="{ 'is-invalid': submitted && formU.password.errors }" />
                                                        <div *ngIf="submitted && formU.password.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formU.password.errors.required">Password is
                                                                required</div>
                                                            <div *ngIf="formU.password.errors.minlength">Password must
                                                                be at least 6 characters</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 p-2">
                                                    <div class="form-group">
                                                        <label>Confirm Password</label>
                                                        <input type="password" formControlName="confirmPassword"
                                                            class="form-control"
                                                            [ngClass]="{ 'is-invalid': submitted && formU.confirmPassword.errors }" />
                                                        <div *ngIf="submitted && formU.confirmPassword.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="formU.confirmPassword.errors.required">Confirm
                                                                Password is required</div>
                                                            <div
                                                                *ngIf="formU.confirmPassword.errors.confirmedValidator">
                                                                Passwords must match</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="" *ngIf="!isAddUser">
                                                <div class="m-3">
                                                    <h3 class="card-title text-left">Change Password (OPTIONAL)</h3>
                                                </div>

                                                <div class="form-row m-0 p-0">
                                                    <div class="col-md-6 p-2">
                                                        <div class="form-group">
                                                            <label>Password</label>
                                                            <input type="password" formControlName="password"
                                                                class="form-control"
                                                                [ngClass]="{ 'is-invalid': submitted && formU.password.errors }" />
                                                            <div *ngIf="submitted && formU.password.errors"
                                                                class="invalid-feedback">
                                                                <div *ngIf="formU.password.errors.required">Password is
                                                                    required</div>
                                                                <div *ngIf="formU.password.errors.minlength">Password
                                                                    must be at least 6 characters</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 p-2">
                                                        <div class="form-group">
                                                            <label>Confirm Password</label>
                                                            <input type="password" formControlName="confirmPassword"
                                                                class="form-control"
                                                                [ngClass]="{ 'is-invalid': submitted && formU.confirmPassword.errors }" />
                                                            <div *ngIf="submitted && formU.confirmPassword.errors"
                                                                class="invalid-feedback">
                                                                <div *ngIf="formU.confirmPassword.errors.required">
                                                                    Confirm Password is required</div>
                                                                <div
                                                                    *ngIf="formU.confirmPassword.errors.confirmedValidator">
                                                                    Passwords must match</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="form-group">
                                                <label class="label-header">Profile Image:</label>
                                                <div class="uploader">

                                                    <input id="file-upload-profile" type="file" name="fileUpload"
                                                        accept="image/*" (change)="onProfileFileChange($event)" />

                                                    <label for="file-upload-profile" id="file-drag">
                                                        <img [src]="profileImage" *ngIf="profileImage"
                                                            onerror="this.src='/assets/grt.svg'" id="file-image">
                                                        <div id="start" *ngIf="!profileImage">
                                                            <img src="assets/profile-placeholder.png" id="icon"
                                                                alt="" />
                                                            <!-- <i class="fa fa-download" aria-hidden="true"></i> -->
                                                            <div class="label-header">Select a Picture</div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-center mt-3">
                                        <button *ngIf="!isAddUser" class="btn btn-success mr-3 btn-w">Update</button>
                                        <button *ngIf="!isAddUser" class="btn btn-info btn-w" type="cancel"
                                            (click)="addNewUser()">Add User</button>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="overlay" [ngClass]="{ 'show': isLoading }"></div>
<div class="spanner" [ngClass]="{ 'show': isLoading }">
    <div class="loader"></div>
    <p>Loading ...</p>


</div>
<app-confirm-dialog></app-confirm-dialog>